import React, {useState} from 'react';
import {
  Image,
  Pressable,
  Animated,
  ViewStyle,
  ImageStyle,
  TextStyle,
} from 'react-native';
import {RootNavigatorParams, Routes} from 'navigation/Routes';
import colors from 'theme/Colors';
import {spacing, corner_radius} from 'theme/Units';
import {useNavigation, useRoute} from '@react-navigation/native';
import {NativeStackNavigationProp} from '@react-navigation/native-stack';
import {ScrollView} from 'react-native-web';
import {Text} from 'ui-kits/Text';

const sidebarMenus = [
  {
    label: 'Project Status',
    icon: require('assets/icons/pro-status.png'),
    activeIcon: require('assets/icons/pro-status-active.png'),
    route: Routes.PROJECT_STATUS,
  },

  {
    label: 'Project Requirement',
    icon: require('assets/icons/pro-requirements.png'),
    activeIcon: require('assets/icons/pro-requirement-active.png'),
    route: Routes.PROJECT_REQUIREMENT,
  },

  {
    label: 'Team Management',
    icon: require('assets/icons/pro-team.png'),
    activeIcon: require('assets/icons/pro-team-active.png'),
    route: Routes.TEAM_MANAGEMENT,
  },

  {
    label: 'Project Management',
    icon: require('assets/icons/pro-management.png'),
    activeIcon: require('assets/icons/pro-management-active.png'),
    route: Routes.PROJECT_MANAGEMENT,
  },

  {
    label: 'Document Management',
    icon: require('assets/icons/pro-doc-manage@2x.png'),
  },
  {label: 'Project Level Chat', icon: require('assets/icons/pro-chat.png')},
  {label: 'Git Repo Access', icon: require('assets/icons/pro-git.png')},
  {
    label: 'Deployment Management',
    icon: require('assets/icons/pro-deployment.png'),
  },
  {
    label: 'Documentations',
    icon: require('assets/icons/pro-documentation.png'),
  },
  {label: 'API Management', icon: require('assets/icons/pro-api.png')},
  {label: 'Design Tool Access', icon: require('assets/icons/pro-design.png')},
];

export function Sidebar() {
  const route = useRoute();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const navigation =
    useNavigation<NativeStackNavigationProp<RootNavigatorParams>>();
  const widthValue = React.useRef(
    new Animated.Value(isOpen ? 245 : 70),
  ).current;
  React.useEffect(() => {
    Animated.timing(widthValue, {
      toValue: isOpen ? 270 : 70,
      duration: 200,
      useNativeDriver: false,
    }).start();
  }, [isOpen, widthValue]);

  return (
    <Animated.View style={[styles.sidebar, {width: widthValue}]}>
      {/* Collapse Button */}
      <Pressable onPress={() => setIsOpen(!isOpen)}>
        <Image
          style={styles.collapseBtn}
          source={
            isOpen
              ? require('assets/icons/cheveron-left.png')
              : require('assets/icons/cheveron-right.png')
          }
        />
      </Pressable>

      {/* Menu Items */}
      <ScrollView style={styles.scrollContainer} id="scroll-none">
        {sidebarMenus.map(item => {
          const isMenuActive = route.name === item.route;
          const isNavigable = item.route !== undefined;

          return (
            <Pressable
              key={item.label}
              onPress={() =>
                isNavigable && navigation.navigate(item.route as any)
              }
              style={[styles.menuItem]}>
              <Image
                source={isMenuActive ? item.activeIcon : item.icon}
                style={styles.icon}
              />
              {isOpen && (
                <Text variant="sourcesans16" style={styles.menuLabel}>
                  {item.label}
                </Text>
              )}
            </Pressable>
          );
        })}
      </ScrollView>
    </Animated.View>
  );
}
type styleProps = {
  sidebar: ViewStyle;
  collapseBtn: ImageStyle;
  menuItem: ViewStyle;
  menuLabel: TextStyle;
  icon: ImageStyle;
  scrollContainer: ViewStyle;
};
const styles: styleProps = {
  sidebar: {
    height: 'fit-content',
    backgroundColor: colors.palette.white,
    borderWidth: 1.5,
    borderColor: colors.palette.stroke,
    justifyContent: 'flex-start',
    zIndex: 1000,
    position: 'relative',
    borderRadius: corner_radius['rounded-md'],
  },
  scrollContainer: {
    flex: 1,
  },
  collapseBtn: {
    width: 24,
    height: 24,
    position: 'absolute',
    right: -24,
    top: 16,
    resizeMode: 'contain',
    zIndex: 999,
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: spacing[2],
    paddingHorizontal: spacing[4],
  },
  menuLabel: {
    color: colors.palette.black,
    marginLeft: spacing[2],
  },
  icon: {
    width: 40,
    height: 40,
    resizeMode: 'contain',
  },
};
